import { render, staticRenderFns } from "./QuizHeader.vue?vue&type=template&id=4f53278c&"
import script from "./QuizHeader.vue?vue&type=script&lang=js&"
export * from "./QuizHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports